import React from "react";
import CelticPersonaPage from "@/components/CelticPersonaPage";
import { BardeChat } from "@/components/CelticChats";
import { Feather } from "lucide-react";

const CONTENT = {
  fr: {
    name: "Le Barde", kicker: "Le Barde · gratuit · anonyme · illimité",
    title: <>Le <span className="italic" style={{ color: "var(--gold-glow)" }}>Barde</span>, gardien des histoires.</>,
    intro: "Dans l'Irlande et la Gaule anciennes, le barde chantait les généalogies, les exploits et les satires. Sa parole pouvait honorer un roi ou le ridiculiser. Ici, il s'assoit avec toi au coin du feu : il écoute, taquine, raconte, et te renvoie toujours une question qui t'aide à trouver ta propre voie.",
    facts: [
      ["La mémoire vivante", "Les bardes apprenaient des centaines de récits par cœur : la culture celte se transmettait oralement, de voix en voix."],
      ["La satire sacrée (áer)", "On disait qu'une satire bardique pouvait faire rougir le visage d'un roi. L'humour était une arme contre la prétention."],
      ["Les trois airs de la harpe", "Geantraí (la joie), Goltraí (les larmes) et Suantraí (le sommeil) : la musique soignait autant qu'elle amusait."],
    ],
    chatTitle: "Parle au Barde",
  },
  en: {
    name: "The Bard", kicker: "The Bard · free · anonymous · unlimited",
    title: <>The <span className="italic" style={{ color: "var(--gold-glow)" }}>Bard</span>, keeper of stories.</>,
    intro: "In ancient Ireland and Gaul, the bard sang genealogies, great deeds and satires. His words could honour a king or mock him. Here he sits with you by the fire: he listens, teases, tells tales, and always hands you back a question that helps you find your own way.",
    facts: [
      ["Living memory", "Bards learned hundreds of tales by heart: Celtic culture travelled orally, from voice to voice."],
      ["Sacred satire (áer)", "A bardic satire was said to make a king's face blush. Humour was a weapon against pretension."],
      ["The three airs of the harp", "Geantraí (joy), Goltraí (tears) and Suantraí (sleep): music healed as much as it entertained."],
    ],
    chatTitle: "Talk to the Bard",
  },
};

export default function Barde() {
  return (
    <CelticPersonaPage id="barde" Icon={Feather} accent="#f5d572" content={CONTENT}>
      <BardeChat />
    </CelticPersonaPage>
  );
}
